import { AdminCatalogTableRow, adminCatalogItem } from "./types/index"

export const adminCatalogMockData: AdminCatalogTableRow[] = [
	{
		id: 1,
		catalogName: "CATALOGS.CATALOGS_LIST.ROOF_BEAMS.name",
		description: "CATALOGS.CATALOGS_LIST.ROOF_BEAMS.description",
		amountOfitems: "12",
		mainInfluenceField: "ENGINEERING/CALC",
		visualIntegration: "UPDATING_DIAGRAM",
	},
	{
		id: 2,
		catalogName: "CATALOGS.CATALOGS_LIST.SIDE_DOOR_WALL.name",
		description: "CATALOGS.CATALOGS_LIST.SIDE_DOOR_WALL.description",
		amountOfitems: "8",
		mainInfluenceField: "SPACING_LOGIC",
		visualIntegration: "DIAGRAMMATIC_LAYOUT",
	},
	{
		id: 3,
		catalogName: "CATALOGS.CATALOGS_LIST.FLOOR_TYPES.name",
		description: "CATALOGS.CATALOGS_LIST.FLOOR_TYPES.description",
		amountOfitems: "15",
		mainInfluenceField: "HEIGHT/WEIGHT",
		visualIntegration: "STATIC_LAYER",
	},
]

export const adminCatalogItemMockData: adminCatalogItem[] = [
	{
		id: 1,
		itemCode: "RB-AL-40",
		itemName: "CATALOGS.CATALOG_ITEMS.RB_AL_40.itemName",
		profileHeight: "40mm",
		weightPerMeter: "1.8 kg",
		technicalNote: "CATALOGS.CATALOG_ITEMS.RB_AL_40.technicalNote",
	},
	{
		id: 2,
		itemCode: "RB-ST-60",
		itemName: "CATALOGS.CATALOG_ITEMS.RB_ST_60.itemName",
		profileHeight: "60mm",
		weightPerMeter: "4.2 kg",
		technicalNote: "CATALOGS.CATALOG_ITEMS.RB_ST_60.technicalNote",
	},
	{
		id: 3,
		itemCode: "RB-SL-110",
		itemName: "CATALOGS.CATALOG_ITEMS.RB_SL_110.itemName",
		profileHeight: "120mm",
		weightPerMeter: "6.5 kg",
		technicalNote: "CATALOGS.CATALOG_ITEMS.RB_SL_110.technicalNote",
	},
]

